import Vue from 'vue';
import VueRouter from 'vue-router';
import news from './routes/news';
import job from './routes/job';
import document from './routes/document';
import form from './routes/form';
import activity from './routes/activity';
import faq from './routes/faq';
import km from './routes/km';
import about from './routes/about';
import calendar from './routes/calendar';
import slide from './routes/slide';
import academic from './routes/academic';

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('@/components/layouts/Admin'),
    children: [
      { path: '/', name: 'Home', component: () => import('@/views/Home') },
      ...news,
      ...job,
      ...document,
      ...form,
      ...activity,
      ...faq,
      ...km,
      ...about,
      ...calendar,
      ...slide,
      ...academic
    ]
  },
  { path: '/login', name: 'Login', component: () => import('@/views/Login') },
]

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const app_token = localStorage.getItem('PERSONNEL_ACCESS_TOKEN');

  if(to.name !== 'Login' && !app_token) {
    next({ name: 'Login' });
  } else {
    next();
  }

  if(to.name === 'Login' && app_token) {
    next({ name: 'Home' });
  } else {
    next();
  }

});



export default router
